import api from './httpClient';

const buildQuery = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') search.set(key, value);
  });
  const query = search.toString();
  return query ? `?${query}` : '';
};

export const fetchTickets = async (params) => {
  const res = await api.get(`/api/tickets${buildQuery(params)}`);
  return res.data;
};

export const updateTicket = async (ticketId, payload) => {
  const res = await api.put(`/api/tickets/${ticketId}`, payload);
  return res.data;
};

export const deleteTicket = async (ticketId) => {
  const res = await api.delete(`/api/tickets/${ticketId}`);
  return res.data;
};
